import { Contract } from './contract';
import { LeaseAgreementCategory, OrganizationOfTenantsKind, RentalObjectCategory } from './const/enums';
import { DwellingInspection } from '../../dwelling-inspection/model/dwelling-inspection';
import { LeaseAgreementForm } from './lease-agreement-form';
import { SubleaseRequest } from './sublease-request';
import { CooperativeHousingOwner } from './CooperativeHousingOwner';
import { BrfMortgagePrescription } from './brf-mortgage-prescription';
import { BrfTransfer } from './Transfer/brftransfer';

export class CooperativeHousingContract extends Contract {
  constructor() {
    super(LeaseAgreementCategory.CooperativeHousing);
    this.subleaseRequests = [];
    this.owners = [];
    this.brfMortgagePrescriptions = [];
  }

  private _subleaseRequest: SubleaseRequest[] = [];

  get subleaseRequests(): SubleaseRequest[] {
    return this._subleaseRequest;
  }
  set subleaseRequests(items: SubleaseRequest[]) {
    if (items instanceof Array) {
      items.forEach(item => {
        if (item instanceof SubleaseRequest) this._subleaseRequest.push(item);
        else this._subleaseRequest.push(Object.assign(new SubleaseRequest(), item));
      });
    }
  }

  private _brfMortgagePrescriptions: BrfMortgagePrescription[] = [];

  get brfMortgagePrescriptions(): BrfMortgagePrescription[] {
    return this._brfMortgagePrescriptions;
  }
  set brfMortgagePrescriptions(items: BrfMortgagePrescription[]) {
    this._brfMortgagePrescriptions = items instanceof Array
      ? items.map(item => (item instanceof BrfMortgagePrescription ? item : new BrfMortgagePrescription(item)))
      : [];
  }

  owners: CooperativeHousingOwner[];
  rentalObjectCategory: RentalObjectCategory;
  atticStorageNumber: string;
  basementStorageNumber: string;
  otherStorageNumber: string;
  parkingIncludedInRent: string;
  currencyCode: string;
  brfTransfer: BrfTransfer;

  toJSON() {
    let json = super.toJSON();
    json.subleaseRequests = this.subleaseRequests;
    json.brfMortgagePrescriptions = this.brfMortgagePrescriptions;
    // Cooperative-housing agreements have no notice-period concept: the UI never renders
    // the sub-form and CooperativeHousingAgreementMappingExtensions never reads or writes
    // NoticePeriod server-side -- accessDate/fromDate is the only field persisted. The
    // base contract form still contributes an empty 'noticePeriod' group, which makes
    // ASP.NET Core recurse into NoticePeriodFormModel's validation and unconditionally
    // demand NoticePeriod.From, rejecting otherwise-valid updates. Drop it from the wire
    // format only -- the live model keeps a real NoticePeriod, because Contract's
    // toDate accessors and super.toJSON() above dereference it.
    json.noticePeriod = null;

    return json;
  }
}
